import React from "react";
import { Link } from "react-router-dom";
import SuccessIcon from "../assets/icons/success.svg"
import "../styles/Styles.css";

function FormSuccess() {

    return (
        <div className="container-fluid bg-green-dark" style={{height: '100vh'}}>
            <div className="container bg-cream h-100 d-flex justify-content-center align-items-center flex-column">
                <img src={SuccessIcon} alt="Success" className="icon-xlarge mb-3" />
                <p className="fs-1 text-success text-center mb-1">Twoja wiadomość została wysłana</p>
                <Link to={"/kontakt"} className="text-green-light">Kliknij, aby powrócić do strony kontaktu</Link>
            </div>
        </div>
    )

    }

    export default FormSuccess;